import { renderReact } from 'hypernova-react'
import { LogoContainerWithStore } from '../../components/header/logo/logoWithStore.container'

export function initCommonComponents() {
  renderReact('LogoContainer', LogoContainerWithStore)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/entry_points/common/common.js